import { RelatorioLancamentoFinanceiroPorMesModel } from "../../../../../../models/relatorio/relatorioLancamentoFinanceiroPorMesModel";
import { sortAnoMes } from "./sortAnoMes";
import dayjs from "dayjs";

dayjs.locale("pt-br");

export interface PivotedData {
  codigo: string;
  denominacao: string;
  nivel: number;
  id: number;
  [anoMes: string]: { valor: number; dataAnoMes: Date } | string | number;
}

export const pivotData = (data: RelatorioLancamentoFinanceiroPorMesModel[]): PivotedData[] => {
  const uniqueAnoMes = Array.from(new Set(data.map((item) => item.anoMes)));
  const sortedAnoMes = sortAnoMes(uniqueAnoMes);

  const groupedData = data.reduce((acc, item) => {
    const key = `${item.codigo}_${item.denominacao}_${item.nivel}_${item.id}`;
    if (!acc[key]) {
      acc[key] = {
        codigo: item.codigo,
        denominacao: item.denominacao,
        nivel: item.nivel,
        id: item.id,
        [item.anoMes]: { valor: item.valor, dataAnoMes: item.dataAnoMes },
      };
    } else {
      acc[key][item.anoMes] = { valor: item.valor, dataAnoMes: item.dataAnoMes };
    }
    return acc;
  }, {} as { [key: string]: PivotedData });

  const pivoted = Object.values(groupedData).map((item) => {
    sortedAnoMes.forEach((anoMes) => {
      if (!(anoMes in item)) {
        item[anoMes] = { valor: 0, dataAnoMes: dayjs().startOf("month").toDate() };
      }
    });
    return item;
  });

  return pivoted;
};
